import * as types from "../../constants/actionTypes";

const siteZones = (state = {}, action) => {
  switch (action.type) {
    case types.INITIATE_SITE_ZONE:
      return {
        ...state,
        [action.zoneId]: {
          id: action.zoneId,
          name: action.name,
          type: action.zoneType
        }
      };
    case types.REMOVE_SITE_ZONE:
      const { [action.zoneId]: v1, ...newState } = state;
      return newState;
    case types.REPLACE_SITE_ZONE:
      const { [action.oldId]: v2, ...newState2 } = state;
      return {
        ...newState2,
        [action.zoneId]: {
          id: action.zoneId,
          name: action.name,
          type: action.zoneType
        }
      };
    case types.REMOVE_ALL_SITE_ZONES:
      return {};
    default:
      return state;
  }
};

export default siteZones;
